<template>
  <div class="row align-items-center full-height">
    <div class="col full-height angled-11deg">
      <div class="instructions">
        <h2>Sign In</h2>
        <p>Please sign in to access your account. If you do not have an account please sign up.</p>
      </div>
      <small class="copyright left">iPro<span class="registeredTrademark">&reg;</span> Systems &copy; {{ new Date().getFullYear() }}</small>
    </div>
    <div class="col" v-if="step === 'signin'">
      <form class="login" >
        <notification v-if="notification" :notification.sync="notification" class="authModule"></notification>
        <div class="container--login">
          <label for="username">Email
            <input type="text" id="username" name="username" v-model="username" />
          </label>

          <label for="password">Password
            <div class="passCon">
              <input type="password" id="password" name="password" v-model="password" />
              <font-awesome-icon class="displayPassword" :icon="iconReturn"  @click="showPassword()"/>
            </div>
          </label>

          <div class="relative">
            <router-link tag="a" to='forgotpassword' class="">Forgot Password?</router-link>
          </div>

          <button @click.prevent="login" type="submit">Log In</button>
        </div>
      </form>
    </div>
    <component :is="step" v-else-if="step === 'createNewPassword'" :user="user"></component>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify'
import notification from './notification'
import { notificationTrigger } from '../mixins/notification.js'

export default {
  name: 'login',
  data () {
    return {
      iconReturn: ['far', 'eye-slash'],
      username: '', // Labeled as email but passed as username for aws
      password: '',
      signedIn: '',
      groups: '',
      user: '',
      step: 'signin'
    }
  },
  mixins: [notificationTrigger],
  components: {
    'notification': notification,
    'createNewPassword': () => import('./Auth/createNewPassword')
  },
  computed: {
  },
  methods: {
    showPassword () {
      let inputType = document.querySelector('#password').type
      if (inputType === 'password') {
        document.querySelector('#password').type = 'text'
        this.iconReturn = ['far', 'eye']
      } else {
        document.querySelector('#password').type = 'password'
        this.iconReturn = ['far', 'eye-slash']
      }
    },
    async login () {
      let self = this
      let redirectLoc = self.$route.query.redirect
      try {
        this.user = await Auth.signIn(this.username, this.password)
        if (this.user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          this.step = 'createNewPassword'
        } else {
          if (this.user.signInUserSession) {
            if (redirectLoc !== undefined) {
              window.location.replace(redirectLoc)
            } else {
              self.$store.dispatch('setUser', this.user)
              self.$router.push({name: 'dashboard'})
            }
          }
        }
      } catch (err) {
        this.savingAnimation('validate', [err.message])
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../less/elements/color.less';
@import '../less/utils/mixins.less';
@import '../less/components/auth.less';

</style>



// WEBPACK FOOTER //
// src/components/login.vue